import { useState } from 'react'

import { LayersConfig } from '@/components/map/layers-view-control'

export const useManageLayersVisibility = <T extends LayersConfig>(
  layersConfig: T,
) => {
  const [layersVisibility, setLayersVisibility] = useState<T>(layersConfig)

  const handleLayerChange = (layerName: string, checked: boolean) => {
    const layerConfig = layersConfig[layerName]
    if (layerConfig?.disabled) return

    setLayersVisibility((prev) => ({
      ...prev,
      [layerName]: { ...prev[layerName], checked },
    }))
  }

  return {
    layersVisibility,
    handleLayerChange,
  }
}
